/* eslint-disable @typescript-eslint/default-param-last */
/* eslint-disable import/prefer-default-export */
import { GET_ADMIN_NOTES, GET_TREATMENT_PLANNING_NOTES } from "./constants";
import default_notes from "../../../assets/js/treatmentNotes.json";
import { deepClone } from "../../../utils/commonFunctions";

const initSetting = {
  user_notes: deepClone(default_notes),
  admin_notes: [],
};

export const treatmentPlanningReducer = (state = initSetting, action) => {
  switch (action.type) {
    case GET_TREATMENT_PLANNING_NOTES: {
      return {
        ...state,
        user_notes: action.payload,
      };
    }
    case GET_ADMIN_NOTES: {
      return {
        ...state,
        admin_notes: action.payload,
      };
    }
    default:
      return state;
  }
};
